import { render, staticRenderFns } from "./BindAddress.vue?vue&type=template&id=71cead86&scoped=true"
import script from "./BindAddress.vue?vue&type=script&lang=js"
export * from "./BindAddress.vue?vue&type=script&lang=js"
import style0 from "./BindAddress.vue?vue&type=style&index=0&id=71cead86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cead86",
  null
  
)

export default component.exports